import { useRouter } from "next/router";
import { useContext } from "react";
import { DomainContext, HostAuthorContext } from "../context/domainContext";
import { RequestHost } from "../types/headers";

export const usePublicAuthorSlug = () => {
    const router = useRouter();
    const requestHostHeader: RequestHost = useContext(DomainContext) ?? RequestHost.MAINDOMAIN;
    const isMainDomain = requestHostHeader === RequestHost.MAINDOMAIN;
    const hostAuthor = useContext(HostAuthorContext);
    const authorSlug = isMainDomain ? (router.query.author as string) : hostAuthor!;

    return authorSlug;
};
